import { API_URL } from "../config/api";

export type Club = {
  number: string;
  name: string;
};

let clubsPromise: Promise<Club[]> | null = null;

// Liste chargée une seule fois par session. En cas d'échec, on renvoie
// une liste vide (la saisie manuelle reste possible) et on réessaiera
// au prochain appel.
export function getClubs(): Promise<Club[]> {
  if (!clubsPromise) {
    clubsPromise = fetch(`${API_URL}/clubs`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .catch(() => {
        clubsPromise = null;
        return [];
      });
  }

  return clubsPromise;
}

// "J.C. Sambreville", "jc sambreville" et "JC-SAMBREVILLE" doivent
// tous correspondre à "J.C.SAMBREVILLE".
export function normalizeClubText(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}
